import React, { ReactElement, WeakValidationMap } from 'react';
import PropTypes from 'prop-types';
import ForgePropTypes from '../utils/propTypes';
import Heading from '../Heading';

import { forgeClassHelper } from '../utils/classes';

const classes = forgeClassHelper({ name: 'banner-item' });

export interface BannerItemProps extends React.HTMLAttributes<HTMLDivElement> {
  /** BannerItem content */
  children?: React.ReactNode;
  /** Adds a class to the root element of the component */
  className?: string;
  /** header text for each banner item, wrapped in an heading element as specified by headingTag */
  headerText?: string;
  /** Specifies the header's HTML tag. For more on the importance of heading tags in semantic HTML,
   * [see the W3C's article on this topic](https://www.w3.org/WAI/tutorials/page-structure/headings/). */
  headingTag?: string; // TODO-TYPES: should use ForgeTypes headingTags
}

/**
 * BannerItem
 * @documentedBy Banner
 */
const BannerItem = ({
  headerText,
  headingTag = 'h2',
  className,
  children,
  ...passedProps
}: BannerItemProps): ReactElement => (
  <div {...classes({ extra: className })} {...passedProps}>
    {headerText && (
      <Heading {...classes({ element: 'header' })} text={headerText} headingTag={headingTag} variant="subsection" />
    )}
    <div {...classes({ element: 'contents' })}>{children}</div>
  </div>
);

const bannerItemPropTypes: WeakValidationMap<BannerItemProps> = {
  /** BannerItem content */
  children: PropTypes.node,
  /** header text for each banner item, wrapped in an heading element as specified by headingTag */
  headerText: PropTypes.string,
  /** Specifies the header's HTML tag. For more on the importance of heading tags in semantic HTML,
   * [see the W3C's article on this topic](https://www.w3.org/WAI/tutorials/page-structure/headings/). */
  headingTag: ForgePropTypes.headingTags,
  /** Adds a class to the root element of the component */
  className: PropTypes.string,
};
BannerItem.propTypes = bannerItemPropTypes;

export default BannerItem;
